const MANAGED_IMAGE_HOSTS = new Set([
  'img-cdn.zhiyitech.cn',
  'zhiyi-image.oss-cn-hangzhou.aliyuncs.com',
  'zhiyi-image-cdn.zhiyitech.cn',
  'cdn.zhiyitech.cn',
  'zhiyi-web.oss-cn-hangzhou.aliyuncs.com',
  'zhiyi-web.zhiyitech.cn',
])

export function isManagedImageUrl(url) {
  if (typeof url !== 'string' || !url.trim()) return false
  try {
    return MANAGED_IMAGE_HOSTS.has(new URL(url, 'https://invalid.local').hostname.toLowerCase())
  } catch {
    return false
  }
}

function getTransferredImageUrl(res) {
  if (typeof res === 'string') return res
  if (typeof res?.data === 'string') return res.data
  if (typeof res?.result === 'string') return res.result
  return res?.url || res?.mainUrl || res?.data?.url || res?.data?.mainUrl || res?.result?.url || res?.result?.mainUrl || ''
}

export async function normalizeWorkflowImageUrls(urls, transferImage, cache = new Map()) {
  return Promise.all(urls.map(async url => {
    if (isManagedImageUrl(url)) return url

    let transferPromise = cache.get(url)
    if (!transferPromise) {
      transferPromise = Promise.resolve(transferImage(url))
        .then(getTransferredImageUrl)
        .then(transferredUrl => {
          if (!isManagedImageUrl(transferredUrl)) throw new Error('invalid transferred image url')
          return transferredUrl
        })
        .catch(error => {
          cache.delete(url)
          throw error
        })
      cache.set(url, transferPromise)
    }
    return transferPromise
  }))
}
